import type { ReactElement } from "react";
import { Select, Space } from "antd";
import type { GoodsSpec } from "@/types/shopGoods";
import type { CatalogRecord } from "@/types/shopCatalog";
import { setSkuSpecificationValue } from "./specifications";

interface SkuSpecificationSelectProps {
  id?: string;
  value?: string;
  onChange?: (value: string) => void;
  specs: GoodsSpec[];
  options: CatalogRecord[];
  disabled?: boolean;
  originalIds?: string;
  originalNames?: string;
}
export function SkuSpecificationSelect({ id, value, onChange, specs, options, disabled, originalIds, originalNames }: SkuSpecificationSelectProps): ReactElement {
  if (specs.length === 0) {
    return <Select id={id} aria-label="规格组合" disabled placeholder="请先添加规格项" style={{ width: "100%" }} />;
  }
  const selected = (value ?? "").split(",");
  const originalValues = (originalIds ?? "").split(",");
  const originalLabels = (originalNames ?? "").split(",");
  return <Space wrap>
    {specs.map((spec, index) => {
      const values = options.filter((item) => String(item.specId) === String(spec.specId)).map((item) => ({
        label: item.specValue ?? String(item.id), value: String(item.id), disabled: item.status !== 1,
      }));
      const current = selected[index];
      if (current && !values.some((item) => item.value === current)) {
        const oldIndex = originalValues.indexOf(current);
        values.push({ label: originalLabels[oldIndex] || `规格值 ${current}`, value: current, disabled: true });
      }
      return <Select
        key={String(spec.specId) || `new-${index}`} id={index === 0 ? id : undefined}
        aria-label={spec.specName || `规格项 ${index + 1}`}
        placeholder={spec.specId ? `请选择${spec.specName || "规格值"}` : "请先选择规格项"} style={{ minWidth: 150 }}
        showSearch allowClear optionFilterProp="label" disabled={disabled || !spec.specId}
        value={current || undefined} options={values}
        onChange={(next: string | undefined) => onChange?.(setSkuSpecificationValue(value, index, next, specs.length))}
      />;
    })}
  </Space>;
}
